import { UserSummaryProductModel } from './user-summary-product.model';

export class UserSummaryModel {
    firstName: string;
    lastName: string;
    email: string;
    contactNumber: string;
    id: string;
    displayName: string;
}
